import 'whatwg-fetch';
import config from '../config/config';

export default {
    get(url: string, data?: any, domain?: string) {
        let queryStr = '';
        if(typeof data !== 'undefined') {
            if(Object.prototype.toString.call(data) === '[object Object]') {
                queryStr = '?';
                for(const keys of Object.keys(data)) {
                    queryStr += keys + '=' + data[keys] + '&';
                }
                queryStr = queryStr.substr(0, queryStr.length-1);
            } else if(typeof data === 'string') {
                queryStr = `?${data}`;
            } else {
                throw '调用apiServer的get方式传入数据必须为字符串或者对象';
            }
        }
        return fetch(`${domain ? domain : config.ROOTAPI}${url}${queryStr}`, {
            credentials: 'include'
        }).then(response => response.json());
    },
    post(url: string, data?: any, domain?: string) {
        if(typeof data !== 'undefined' && Object.prototype.toString.call(data) !== '[object Object]') {
            throw '调用apiServer的post方式传入数据必须为对象';
        }
        return fetch(`${domain ? domain : config.ROOTAPI}${url}`, {
            method: 'post',
            body: JSON.stringify(data),
            credentials: 'include'
        }).then(response => response.json());
    }
}


// WEBPACK FOOTER //
// ./src/server/apiServer.ts